module.exports = __webpack_public_path__ + "static/img/home-active.bc65c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/home-active.png
// module id = X4/I
// module chunks = 26